import { c as _c } from "react/compiler-runtime";
import { IcoArrowDown16, IcoArrowUp16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { useEffect, useRef, useState } from 'react';
type MoveControlsProps = {
  canUp: boolean;
  canDown: boolean;
  onMove: (direction: 'up' | 'down') => void;
  /** 'hover' (default) reveals the controls when a `.group` or `.group/pane` ancestor is hovered, or they hold focus; 'always' keeps them visible. */
  visibility?: 'hover' | 'always';
};
const BUTTON = 'w-6 h-6 max-md:size-8 rounded-(--icon-button-border-radius-tiny) max-md:rounded-(--icon-button-border-radius) flex items-center justify-center cursor-pointer hover:bg-hover-control aria-disabled:cursor-default aria-disabled:opacity-40 aria-disabled:hover:bg-none';
const MoveControls = t0 => {
  const $ = _c(25);
  const {
    canUp,
    canDown,
    onMove,
    visibility: t1
  } = t0;
  const visibility = t1 === undefined ? "hover" : t1;
  const upRef = useRef(null);
  const downRef = useRef(null);
  const [lastMove, setLastMove] = useState(null);
  let t2;
  let t3;
  if ($[0] !== lastMove) {
    t2 = () => {
      if (!lastMove) {
        return;
      }
      (lastMove.direction === "up" ? upRef : downRef).current?.focus();
    };
    t3 = [lastMove];
    $[0] = lastMove;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (!canUp && !canDown) {
    return null;
  }
  let t4;
  if ($[3] !== onMove) {
    t4 = (direction, allowed) => {
      if (!allowed) {
        return;
      }
      setLastMove({
        direction
      });
      onMove(direction);
    };
    $[3] = onMove;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const move = t4;
  const t5 = visibility === "hover";
  let t6;
  if ($[5] !== t5) {
    t6 = cx("flex items-center gap-0.5", {
      "md:opacity-0 md:group-hover:opacity-100 md:group-hover/pane:opacity-100 md:focus-within:opacity-100 transition-opacity": t5
    });
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = !canUp || undefined;
  let t8;
  if ($[7] !== canUp || $[8] !== move) {
    t8 = e_0 => {
      e_0.stopPropagation();
      move("up", canUp);
    };
    $[7] = canUp;
    $[8] = move;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IcoArrowUp16 color="tertiary" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t8) {
    t10 = <button aria-disabled={t7} aria-label="Move up" className={BUTTON} onClick={t8} ref={upRef} type="button">{t9}</button>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = !canDown || undefined;
  let t12;
  if ($[14] !== canDown || $[15] !== move) {
    t12 = e_1 => {
      e_1.stopPropagation();
      move("down", canDown);
    };
    $[14] = canDown;
    $[15] = move;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IcoArrowDown16 color="tertiary" />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t11 || $[19] !== t12) {
    t14 = <button aria-disabled={t11} aria-label="Move down" className={BUTTON} onClick={t12} ref={downRef} type="button">{t13}</button>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t10 || $[22] !== t14 || $[23] !== t6) {
    t15 = <div className={t6} onClick={_temp}>{t10}{t14}</div>;
    $[21] = t10;
    $[22] = t14;
    $[23] = t6;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
};
export default MoveControls;
function _temp(e) {
  return e.stopPropagation();
}